import { gql } from '@apollo/client';

export const updateProductsInWishlistMutation = gql`
    mutation($wishlistId: ID!, $itemId: ID!, $configuration: String!) {
        updateProductsInWishlist(
            wishlistId: $wishlistId
            wishlistItems: [
                {
                    wishlist_item_id: $itemId
                    quantity: 1
                    description: $configuration
                }
            ]
        ) {
            wishlist {
                id
                items_count
                items_v2 {
                    items {
                        id
                        description
                        product {
                            id
                            sku
                        }
                    }
                }
            }
            user_errors {
                code
                message
            }
        }
    }
`;
